interface FilterOperator {
  value: string;
  operator: string;
}
export const filterOperatorsValue: FilterOperator[] = [
  { value: '=', operator: 'eq' },
  { value: '!=', operator: 'neq' },
  { value: '>=', operator: 'gte' },
  { value: '>', operator: 'gt' },
  { value: '<', operator: 'lt' },
  { value: '<=', operator: 'lte' },
  { value: 'is null', operator: 'isnull' },
  { value: 'is not null', operator: 'isnotnull' },
  { value: 'contains', operator: 'contains' },
  { value: 'does not contain', operator: 'doesnotcontain' },
  { value: 'starts with', operator: 'startswith' },
  { value: 'ends with', operator: 'endswith' },
];
